module.exports = __webpack_public_path__ + "static/img/icon_wifi.d38d82c7.png";